import React, { PureComponent, PropTypes } from 'react';

class Input extends PureComponent {
    constructor(props, ...args) {
        super(props, ...args);
        this.state = {};

        this.onChange = this.onChange.bind(this);
    }

    onChange(evt) {
        let { onContentChange } = this.props;

        onContentChange(evt.target.value);
    }
    componentDidMount() {
        this.input.focus();
    }

    render() {
        let { content, onBack, onCancel, onComplete, onContentChange } = this.props;

        return (<div className="import-input">
            <h1>Enter your data</h1>
            <textarea ref={ node => this.input = node } value={ content } onChange={ evt => onContentChange(evt.target.value) } />
            <div className="buttons">
                <button onClick={ onBack }>Help</button>
                <button onClick={ onCancel }>Cancel</button>
                <button onClick={ onComplete }>Next</button>
            </div>
        </div>);
    }
}

Input.propTypes = {
    content: PropTypes.string.isRequired,
    onBack: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired,
    onContentChange: PropTypes.func.isRequired
};

export default Input;


// WEBPACK FOOTER //
// ./src/components/importer/input.js